export { default } from './ThemeColor';
